module.exports = __webpack_public_path__ + "img/ziliao_banner_pt.53f0f72f.jpg";